<template>
  <!-- 服务费弹窗 -->
  <van-popup v-model="showServicePop" class="service-popup" position="bottom" get-container="#app">
    <img class="close-btn" @click="showServicePop = false" src="@/static/images/product/icon_close_grey.png" alt="" />
    <div class="title">{{ productName }}</div>
    <div v-if="allData.activityInfoVO || allData.isDynamicRate || allData.merchantActivity" class="activity-title" :class="{ 't-c': !allData.isDynamicRate }">
      <div v-if="allData.isDynamicRate" class="instructions">{{ allData.instructions }}</div>
      <div v-if="allData.activityInfoVO && allData.merchantActivity" class="activity-list">
        <div class="activity-box">
          <span class="dot">1</span>
          <div>
            <p class="">{{ allData.activityInfoVO.title }}</p>
            <p class="activity-time">{{ allData.activityInfoVO.startTime }}至{{ allData.activityInfoVO.endTime }}</p>
          </div>
        </div>
        <div class="activity-box">
          <span class="dot">2</span>
          <div>
            <p>{{ allData.merchantActivity.name }}</p>
            <p class="activity-time">
              {{ allData.merchantActivity.startTime | formatTime('YYYY-MM-DD') }}至{{ allData.merchantActivity.endTime | formatTime('YYYY-MM-DD') }}
            </p>
          </div>
        </div>
      </div>
      <div v-else-if="allData.activityInfoVO" class="activity-list">
        <div class="activity-box1">{{ allData.activityInfoVO.title }}</div>
        <div class="activity-box1">{{ allData.activityInfoVO.startTime }}至{{ allData.activityInfoVO.endTime }}</div>
      </div>
      <div v-else-if="allData.merchantActivity" class="activity-list">
        <div class="activity-box1">{{ allData.merchantActivity.name }}</div>
        <div class="activity-box1">{{ allData.merchantActivity.startTime }}至{{ allData.merchantActivity.endTime }}</div>
      </div>
    </div>
    <ul class="tab-list" v-if="allData.agency && allData.settleRule && allData.settleRule.length">
      <li v-if="allData.agency" @click="serviceTabClick(allData.agency, 0)" :class="{ active: serviceActive == 0 }">服务费</li>
      <li v-if="allData.settleRule && allData.settleRule.length" @click="serviceTabClick(allData.settleRule, 2)" :class="{ active: serviceActive == 2 }">
        结算规则
      </li>
    </ul>
    <div v-if="serviceActive != 2" class="content" id="content">
      <div class="commission-item" :class="{ 'small': list[0].commisionNum > 3 }" v-if="list.length > 0">
        <div class="table" :id="'table'">
          <div class="head">
            <div class="td1">险种名称</div>
            <div class="body">
              <div class="list-row">
                <div class="td" v-if="isGroupGrade == '0'">方案名称</div>
                <div class="td" v-for="rule in ruleList" :key="rule.code">{{ rule.name }}</div>
                <div class="td" v-for="(year, ii) in getYearList(list[0].commisionNum)" :key="ii" v-html="year.name"></div>
              </div>
            </div>
            
          </div>
          <div class="bodymain" v-for="(item1, i) in list" :key="i">
            <div class="tr">
              <div class="tag" v-if="item1.isMain != 1">附</div>
              {{ item1.productName }}
            </div>
            <div class="body">
              <div class="list-row" v-for="(item2, ii) in item1.programBaseList" :key="ii">
                <div class="td" v-if="isGroupGrade == '0'">
                {{item2.name}}
                </div>
                <div class="td" v-for="rule in ruleList" :key="rule.code">
                  {{ getRuleData(item2.factors, rule.code, 'remark') }}
                </div>
                <div class="td" v-for="(data, iiii) in getValues(item2)" :key="iiii">
                  <span>
                    <i v-html="data"></i>
                    <i style="color: #ff5426; display: block" v-if="iiii == 0 && item2.actCommission > 0 && !allData.merchantActivity"
                      >+ {{ item2.actCommission }}%</i
                    >
                    <i style="color: #ff5426; display: block" v-if="iiii == 0 && item2.merchantActivityCommission > 0 && !allData.activityInfoVO"
                      >+ {{ item2.merchantActivityCommission }}%</i
                    >
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="rules-content">
      <div v-for="(item, index) in list" :key="index">
        <div class="name">{{ index + 1 }}.{{ item.name }}</div>
        <div class="content-wrap" v-html="item.content"></div>
      </div>
    </div>
  </van-popup>
</template>

<script>
import { loading } from '@/api/mixins';
export default {
  props: {},
  mixins: [loading],
  data() {
    return {
      productName: '', //服务费弹窗的产品名称
      showServicePop: false, //服务费弹窗
      isDynamicRate: false, //是否显示费用后置
      serviceActive: 0, //服务费弹窗当前选中的tab
      allData: {}, //服务费数据
      list: [],
      isGroupGrade:'1',
      ruleList: [],
      year: [],
      userInfo: {}
    };
  },
  mounted() {
    this.userInfo = JSON.parse(localStorage.getItem('jzy_user'));
  },
  methods: {
    getYearList(num) {
      const year = [];
      for (let index = 0; index < num; index++) {
        if (index == 0) {
          year.push({ name: '首年' });
          if (this.allData.activityInfoVO && this.allData.merchantActivity) {
            year.push({ name: "活动<span class='dot'>1</span>" });
            year.push({ name: "活动<span class='dot'>2</span>" });
          }
          if (this.isDynamicRate) {
            year.push({ name: '后置费率' });
          }
        } else {
          let text = '第' + this.$tools.numberTransform(index + 1) + '年';
          if(this.allData.untilLastCommissionIndex > 0 && index==num-1) {
            text += '至<br>交费期满'
          }
          year.push({ name: text });
        }
      }
      return year;
    },
    /**
     * 获取服务费比例数组
     * @param {*} values 服务费
     * @param {*} postfRateValues 费用后置比例
     */
    getValues(item2) {
      const values = item2.groupValues && item2.groupValues.length ? item2.groupValues : item2.values;
      const postfRateValues = item2.groupPostfRateValues && item2.groupPostfRateValues.length ? item2.groupPostfRateValues : item2.postfRateValues;
      const arr = [].concat(values.map(i => i + '%'));
      let arr1 = [];
      console.log(values);
      if (this.allData.activityInfoVO && this.allData.merchantActivity) {
        arr1.push(`<span style="color: #ff5426;">+${item2.actCommission || 0}%</span>`);
        arr1.push(`<span style="color: #ff5426;">+${item2.merchantActivityCommission || 0}%</span>`);
      }
      if (this.isDynamicRate) {
        if (postfRateValues && postfRateValues[0]) {
          arr1.push(postfRateValues[0] + '%');
        } else {
          arr1.push(0 + '%');
        }
      }
      arr.splice(1, 0, ...arr1);
      return arr;
    },
    hideGrade(list) {},
    serviceTabClick(list, i) {
      this.list = list;
      this.serviceActive = i;
    },
    open(item) {
      this.loading = true;
      this.$http({
        url: '/api/commission/productRateDetailNew',
        type: 'GET',
        data: {
          productCode: item.productCode
        }
      }).then(res => {
        this.loading = false;
        if (res.data.settleRule) {
          res.data.settleRule = JSON.parse(res.data.settleRule);
        }
        console.log(res.data);
        this.allData = res.data;
        this.isGroupGrade = res.data.isGroupGrade;
        this.isDynamicRate = res.data.isDynamicRate;
        this.ruleList = res.data.programRules;
        this.serviceTabClick(res.data.agency, 0);
        this.showServicePop = true;
        this.productName = item.productName;
        window.setTimeout(() => {
          document.getElementById('content').scrollTop = 0;
          document.getElementById('table').scrollLeft = 0;
        }, 200);
      });
    },
    getRuleData(list, code, key) {
      const data = list.find(item => {
        return item.roleCode == code;
      });
      if (data && data[key]) {
        return data[key];
      } else {
        return '-';
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import './serviceBox.scss';
</style>
